export default "Penguin Escape opened in July 2020.";